var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "return_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8680",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6860",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#return_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 12.571v9.144C25 22.977 23.992 24 22.75 24H9.25C8.008 24 7 22.977 7 21.715v-9.144h18ZM20 19.2h-8a.5.5 0 1 0 0 1h6.793l-1.146 1.147a.5.5 0 0 0 .706.707l2-2A.501.501 0 0 0 20 19.2Zm-6.353-4.854-2 2A.501.501 0 0 0 12 17.2h8a.5.5 0 1 0 0-1h-6.793l1.146-1.147a.5.5 0 0 0-.706-.707ZM21.13 8c.667 0 1.3.302 1.728.823l2.138 2.606H7l2.138-2.606A2.231 2.231 0 0 1 10.868 8H21.13Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgReturn;